import "../../sass/header.scss";
import React from "react";
import MenuBar from "./menu-bar";
import Background from "./background";
import { useLocation } from "react-router-dom";
import Logo from "./logo";
import HeaderHomepage from "./header-homepage";

function Header() {
  const location = useLocation();

  if (location.pathname === '/') {
    return <HeaderHomepage />
  }

  return (
    <div id={"header"} style={location.pathname === '/' ? {height: '145px'} : {}}>
      <Background />
      <Logo />
      {location.pathname !== '/' && <MenuBar />}
    </div>
  );
}

export default Header;
